import { HttpResponse } from 'msw';

type LegacyBody = { command?: string; access?: string };

function sampleLogMessages() {
  const priorities = ['CRITICAL', 'ERROR', 'WARNING', 'NOTICE', 'INFO'];
  const services = ['system', 'network', 'dhcp', 'vlan', 'poe'];
  const msgs = [];
  for (let i = 0; i < 20; i += 1) {
    msgs.push({
      pri: priorities[Math.floor(Math.random() * priorities.length)],
      tr: Math.floor(Math.random() * 86400),
      st: new Date(Date.now() - Math.random() * 86400000).toISOString(),
      service: services[Math.floor(Math.random() * services.length)],
      msg: `Sample log message ${i + 1}`,
    });
  }
  return { msgs, overflow: false };
}

export function handleLogLegacy(
  body: LegacyBody,
): ReturnType<typeof HttpResponse.json> {
  const command = body.command ?? '';
  const access = body.access ?? 'get';

  switch (command) {
    case 'get log':
      if (access === 'get') {
        return HttpResponse.json(sampleLogMessages(), { status: 200 });
      }
      break;
    case 'get remote':
      if (access === 'get') {
        return HttpResponse.json(
          {
            enabled: false,
            destination: '',
            protocol: 'udp' as const,
            port: 514,
            mark: false,
            interval: 60,
          },
          { status: 200 },
        );
      }
      break;
    case 'set remote':
      if (access === 'set') {
        return HttpResponse.json({ ok: true }, { status: 200 });
      }
      break;
    case 'remove log':
      if (access === 'set') {
        return HttpResponse.json({ ok: true }, { status: 200 });
      }
      break;
    default:
      break;
  }

  return HttpResponse.json(
    { error: 'not implemented', msg: `Mock missing for log:${command}` },
    { status: 400 },
  );
}
